import { ChevronRight } from "lucide-react";
import React from "react";
import { BotNav } from "../../components/layout/BotNav";
import { Link } from "react-router-dom";
const menuItems = [
  ["Event", "/events"],
  ["Customized travel", "/my-inquiry"],
  ["Hotel Inquiry", "https://google.com"],
  ["Ticket check", "/ticket-check"],
];
const MorePage: React.FC = () => {
  return (
    <>
      <style>
        {` .ui-footer {
        display: none
      }`}
      </style>
      <div className="flex w-full flex-col p-4">
        {menuItems.map(([item, path], index) => (
          <Link
            to={path}
            key={index}
            className="flex items-center justify-between border-b border-gray-200 py-4 last:border-none"
          >
            <span className="text-lg font-medium text-gray-800">{item}</span>
            <ChevronRight className="h-5 w-5 text-gray-400" />
          </Link>
        ))}
      </div>
      <BotNav active="MORE" />
    </>
  );
};

export default MorePage;
